import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpLong = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.646 1.64604C7.84111 1.45093 8.15773 1.45122 8.35303 1.64604L13.353 6.64604C13.5483 6.8413 13.5483 7.15781 13.353 7.35307C13.1578 7.54833 12.8413 7.54834 12.646 7.35307L8.49951 3.20659V13.4996C8.49951 13.7757 8.27565 13.9996 7.99951 13.9996C7.72357 13.9993 7.49951 13.7756 7.49951 13.4996V3.20659L3.35303 7.35307C3.15777 7.54834 2.84126 7.54834 2.646 7.35307C2.45117 7.15778 2.45088 6.84116 2.646 6.64604L7.646 1.64604Z",
		fill: "currentColor"
	})
});
export default SvgArrowUpLong;
